/* Company Data */
const Company = [
    {
        id:0,
        img:'https://img.icons8.com/color/80/null/microsoft.png'
    },
    {
        id:1,
        img:'https://img.icons8.com/color/80/null/google-logo.png'
    },
    {
        id:2,
        img:'https://img.icons8.com/color/80/null/amazon.png'
    },
    {
        id:3,
        img:'https://img.icons8.com/color/80/null/american-express-squared.png'
    },
    {
        id:4,
        img:'https://img.icons8.com/color/80/null/samsung.png'
    },
    {
        id:5,
        img:'https://img.icons8.com/color/80/null/oracle-logo.png'
    },
    {
        id:6,
        img:'https://img.icons8.com/color/80/null/paytm.png'
    },
    {
        id:7,
        img:'https://img.icons8.com/color/80/null/byjus.png'
    },
    {
        id:8,
        img:'https://img.icons8.com/color/80/null/uber-app.png'
    },
    {
        id:9,
        img:'https://img.icons8.com/color/80/null/honda.png'
    },
    {
        id:10,
        img:'https://img.icons8.com/color/80/null/ibm.png'
    },
    {
        id:11,
        img:'https://img.icons8.com/color/80/null/hp.png'
    }
];

export default Company;